import { CapacitorHttp, Capacitor } from '@capacitor/core';

/**
 * Custom fetch implementation for mobile that uses Capacitor's native HTTP
 * to bypass CORS restrictions. Falls back to regular fetch on web.
 */
export async function capacitorFetch(
  input: RequestInfo | URL,
  init?: RequestInit
): Promise<Response> {
  // Use regular fetch on web platform
  if (!Capacitor.isNativePlatform()) {
    return fetch(input, init);
  }

  // Parse the URL
  const url = typeof input === 'string' ? input : input instanceof URL ? input.toString() : input.url;

  // Prepare headers
  const headers: Record<string, string> = {};
  if (init?.headers) {
    if (init.headers instanceof Headers) {
      init.headers.forEach((value, key) => {
        headers[key] = value;
      });
    } else if (Array.isArray(init.headers)) {
      init.headers.forEach(([key, value]) => {
        headers[key] = value;
      });
    } else {
      Object.assign(headers, init.headers);
    }
  }

  try {
    // Make request using Capacitor HTTP (native, bypasses CORS)
    const response = await CapacitorHttp.request({
      url,
      method: init?.method || 'GET',
      headers,
      data: init?.body,
    });

    // Convert Capacitor response to Response-like object
    const responseInit: ResponseInit = {
      status: response.status,
      statusText: response.status.toString(),
      headers: new Headers(response.headers),
    };

    // Capacitor returns data as object, need to stringify for Response
    const body = typeof response.data === 'string'
      ? response.data
      : JSON.stringify(response.data);

    return new Response(body, responseInit);
  } catch (error) {
    console.error('[CapacitorFetch] Error making request to', url, error);
    throw error;
  }
}
